/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    InspectorLoginFormData,
    LoginResponseData,
    OperatorTaxpayerLoginFormData,
    AUTH_API_URLS_PREFIX,
} from './authClient.typings';
import apiClient from '../apiClient';
import { convertToFormData, toHash } from '../../../utils/utils';

async function inspectorLogin(data: InspectorLoginFormData): Promise<LoginResponseData> {
    const password = await toHash(data.password);
    const { username, token, rememberMe } = data;

    return apiClient.post(
        '1.0.0' + AUTH_API_URLS_PREFIX + '/inspector',
        convertToFormData({ username, password, rememberMe }),
        token
            ? {
                  headers: {
                      'Content-Type': 'multipart/form-data',
                      Token: token,
                  },
              }
            : {
                  headers: {
                      'Content-Type': 'multipart/form-data',
                  },
              },
    );
}

const operatorLogin = (data: OperatorTaxpayerLoginFormData): Promise<LoginResponseData> => {
    return apiClient.post('1.0.0' + AUTH_API_URLS_PREFIX + '/operator', convertToFormData({ ...data }), {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const taxpayerLogin = (data: OperatorTaxpayerLoginFormData): Promise<LoginResponseData> => {
    return apiClient.post('1.0.0' + AUTH_API_URLS_PREFIX + '/taxpayer', convertToFormData({ ...data }), {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const logout = (): Promise<void> => {
    return apiClient.post(`1.0.0${AUTH_API_URLS_PREFIX}/logout`, null);
};

export const authClient = {
    inspectorLogin,
    operatorLogin,
    taxpayerLogin,
    logout,
};
